import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface DistrictWideTagProps {
  className?: string;
}

export default function DistrictWideTag({ className }: DistrictWideTagProps) {
  return (
    <Badge
      className={cn(
        "bg-surface-strong text-ink-emphasis font-medium",
        className,
      )}
    >
      District-wide
    </Badge>
  );
}
